import React from "react";
import {
  View,
  Dimensions,
  ScrollView,
  Text,
  StyleSheet,
  Switch,
  Platform,
  TouchableOpacity,
} from "react-native";

import AppTheme from "../AppTheme";
import appStyles from "../../appStyles";
import Header from "../common/header";

import ImageComponent from "../common/ImageComponent";
import TESTING_OPTIONS from "./testing";
import TutorialsHelper from "../tutorials/TutorialsHelper";
import { isWeb, navigate } from "../../../helpers/utils";
import NativeHelper from "../native/NativeHelper";

const { height: HEIGHT, width: WIDTH } = Dimensions.get("window");
const thumbColor = AppTheme.DEFAULT_COLOR;

export default class TestingPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    const { testing_preferences } = this.controller.state?.settings || {};

    this.state = {
      currentUser: this.controller.state?.currentUser,
      ...testing_preferences,
    };
  }

  goBack = () => {
    this.controller.goBack();
  };

  updateSettings = (option, value) => {
    const key = option.value;

    let model = { [key]: value };
    if (key == "health") model.autotrack = value;

    // Show Mari message for early access
    if (option.is_pending && !!value) {
      this.setState((state) => ({
        ...state,
        ...model,
      }));
    } else {
      this.setState((state) => ({ ...state, ...model, mariMessage: "" }));
    }

    this.saveTestingPreferences(model);
  };

  saveTestingPreferences = (data) => {
    const action = {
      action: "save",
      target: "testing",
      ...data,
    };

    this.setState((state) => ({ ...state, isLoading: true }));

    console.log("Save Testing Pref");
    this.controller.cardActionWithCallback(action, () => {
      this.setState((state) => ({ ...state, isLoading: false }));

      this.controller.updateEmbeddedSettings();
    });
  };

  onPressHandler = (model) => {
    const { page, action, actionType = "changepage", page_args = {} } = model;

    if (action == "tutorials") {
      TutorialsHelper.onTutorialClicked(this.controller, model);
    } else {
      navigate(this.controller, page, actionType, page_args);
    }
  };

  render() {
    const { isLoading } = this.state;

    const testingOptions = TESTING_OPTIONS.slice(0);
    if (isWeb) {
      testingOptions.push(...NativeHelper.getOptions());
    }

    return (
      <View style={appStyles.container}>
        <Header
          title="Testing Preferences"
          goBack={this.goBack}
          isLoading={isLoading}
          hideAvatar
        />

        <ScrollView style={styles.scrollView}>
          {testingOptions.map((option) =>
            /* Toggle */
            option.hasToggle ? (
              <View key={option.id}>
                <View style={styles.row}>
                  {/* Image */}
                  {option.icon ? (
                    <ImageComponent image={option.icon} style={styles.icon} />
                  ) : null}

                  {/* Name */}
                  <Text
                    style={[
                      styles.optionText,
                      option.is_subOption ? styles.optionTextSmall : {},
                    ]}
                  >
                    {option.name}
                  </Text>

                  {/* Toggle */}
                  <Switch
                    thumbColor={thumbColor}
                    onValueChange={(value) =>
                      this.updateSettings(option, value)
                    }
                    value={this.state[option.value]}
                  />
                </View>
              </View>
            ) : (
              /* Link */
              <TouchableOpacity
                key={option.id}
                style={styles.link}
                onPress={() => this.onPressHandler(option)}
              >
                {option.icon ? (
                  <ImageComponent
                    image={option.icon}
                    style={styles.imageIcon}
                  />
                ) : option.iconTag ? (
                  <option.iconTag style={[styles.imageIcon]} />
                ) : null}
                <Text style={styles.linkText}>{option.name}</Text>
              </TouchableOpacity>
            ),
          )}
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    width: WIDTH,
    height: HEIGHT,
    ...appStyles.maxWidth,
    margin: "auto",
    display: "flex",
    backgroundColor: "#FFF",
  },
  scrollView: {
    maxHeight: HEIGHT - 130,
    paddingBottom: 100,
    backgroundColor: "#FFF",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    height: 44,
    paddingHorizontal: 15,
  },
  borderTop: {
    borderTopColor: "rgba(0, 0, 0, 0.15)",
    borderTopWidth: 1,
  },
  optionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    textTransform: "capitalize",
    color: "#2D3142",
    flex: 1,
    marginLeft: 10,
  },
  optionTextSmall: {
    fontSize: 12,
    lineHeight: 14,
    marginLeft: 40,
  },
  optionValue: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
    textAlign: "center",
  },
  icon: {
    width: 30,
    height: 30,
  },
  egg: {
    height: 30,
    width: 24,
  },
  link: {
    height: 44,
    paddingLeft: 14,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  linkText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#2D3142",
    display: "flex",
    alignItems: "center",
  },
  imageIcon: {
    width: 30,
    height: 30,
    marginRight: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
